import { executeCloudFunction } from '../index';
import { getProjectErrorFromRawError } from '../../utils/errors';
import { Deal } from '../types/others';

export const getUserByEmail = async (email: string) => {
  try {
    const result = await executeCloudFunction('searchUserByEmail', { email });
    return result?.data;
  } catch (error) {
    console.log('[USER - gerUserByEmail] Error:', error);
    return getProjectErrorFromRawError(error as Error);
  }
};

export const getRevenueCatUser = async (userId: string) => {
  try {
    return await executeCloudFunction('getRevenueCatUser', { userId });
  } catch (error) {
    console.log('[USER - getRevenueCatUser] Error:', error);
    return getProjectErrorFromRawError(error as Error);
  }
};

export const recoverUserSubscriptionIntervals = async (userId: string) => {
  try {
    return await executeCloudFunction('recoverUserSubscriptionIntervals', { userId });
  } catch (error) {
    console.log('[USER - recoverUserSubscriptionIntervals] Error:', error);
    return getProjectErrorFromRawError(error as Error);
  }
};

export const deleteAccountOnAdmin = async (userId: string, paymentInfo: any) => {
  try {
    return await executeCloudFunction('deleteAccountOnAdmin', { userId, paymentInfo });
  } catch (error) {
    console.log('[USER - deleteAccountOnAdmin] Error:', error);
    return getProjectErrorFromRawError(error as Error);
  }
};

export const impersonateUser = async ({ userId }: { userId: string }) => {
  try {
    return await executeCloudFunction('impersonateUser', { userId });
  } catch (error) {
    console.log('[USER] Error at impersonateUser:', error);
    return getProjectErrorFromRawError(error as Error);
  }
};

export const revertUserImpersonation = async () => {
  try {
    return await executeCloudFunction('revertUserImpersonation');
  } catch (error) {
    console.log('[USER] Error at revertUserImpersonation:', error);
    return getProjectErrorFromRawError(error as Error);
  }
};
